import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import styles from './ResetPassword.module.css';
import eyeOpen from '../../../images/icon-eye-open.svg';
import eyeClose from '../../../images/icon-eye-close.svg';
import { useDispatch } from 'react-redux';
import { AppDispatch, IRootState } from '../../../redux/rootReducer';
import { resetPassword } from '../../../redux/auth/actions/resetPassword.action';
import { useSelector } from 'react-redux';
import Toast from '../../common/toast/Toast';

const ResetPassword = () => {
    const { token } = useParams();

    const dispatch: AppDispatch = useDispatch();
    const navigate = useNavigate();

    const message = useSelector((state: IRootState) => state.resetPassword.data);
    const err = useSelector((state: IRootState) => state.resetPassword.errMsg);

    const [showPass, setShowPass] = useState(false);
    const [showConfirmPass, setShowConfirmPass] = useState(false);
    const [password, setPassword] = useState({
        password: '',
        confirmPassword: '',
    });
    const [passErr, setPassErr] = useState('');
    const [confirmPassError, setConfirmPassError] = useState('');
    const [errMessage, setErrMessage] = useState('');

    useEffect(() => {
        if (message.statusCode === 200) {
            navigate('/');
        } else if (err) {
            setErrMessage(err.response.data.message[0]);
            setTimeout(() => {
                setErrMessage('');
            }, 4000);
        }
    }, [message.statusCode, err]);

    const onChangeHandler = (event: React.FormEvent<HTMLInputElement>) => {
        const { name, value } = event.target as HTMLInputElement;

        if (name == 'password') {
            const regularExpression = /^(?=.*[0-9])(?=.*[- ?!@#$%^&*\\])(?=.*[A-Z])(?=.*[a-z])[a-zA-Z0-9- ?!@#$%^&*\\]{8,30}$/;
            regularExpression.test(value)
                ? setPassErr('')
                : setPassErr(
                      'Password must contain numbers, uppercase, letters, at least one special character, must be greater than 8 characters',
                  );
        }

        setPassword({
            ...password,
            [(event.target as HTMLInputElement).name]: (event.target as HTMLInputElement).value,
        });
    };

    const submitHandler = (e: React.FormEvent) => {
        e.preventDefault();
        if (password.password !== password.confirmPassword) {
            setConfirmPassError("Password doesn't match!");
        } else {
            setConfirmPassError('');
            setErrMessage('');
            dispatch(resetPassword({ password: password.password, resetToken: token }));
        }
    };

    return (
        <>
            {message.statusCode === 403 && <Toast message={message.message} type="error" />}
            {errMessage && <Toast message={errMessage} type="error" />}
            <div>
                <div className={styles.loginWrapper}>
                    <h2 className={styles.loginTitle}>Reset Your Password</h2>

                    <p className={styles.loginInfo}>Please enter a new password. </p>

                    <div className={styles.loginForm}>
                        <form onSubmit={submitHandler}>
                            <div className={styles.formWrapper}>
                                <label>Create Password</label>
                                <input
                                    type={showPass ? 'text' : 'password'}
                                    name="password"
                                    value={password.password}
                                    onChange={onChangeHandler}
                                    placeholder="Enter password"
                                />
                                <div className={styles.eyeToggler} onClick={() => setShowPass(!showPass)}>
                                    <img src={!showPass ? eyeClose : eyeOpen} alt="Eye" />
                                </div>
                                {passErr && <p className={styles.error}>{passErr}</p>}
                            </div>

                            <div className={styles.formWrapper}>
                                <label>Confirm Password</label>
                                <input
                                    type={showConfirmPass ? 'text' : 'password'}
                                    name="confirmPassword"
                                    value={password.confirmPassword}
                                    onChange={onChangeHandler}
                                    placeholder="Enter password"
                                />
                                <div className={styles.eyeToggler} onClick={() => setShowConfirmPass(!showConfirmPass)}>
                                    <img src={!showConfirmPass ? eyeClose : eyeOpen} alt="Eye" />
                                </div>
                                {confirmPassError && <p className={styles.error}>{confirmPassError}</p>}
                            </div>

                            <div className={styles.formSubmit}>
                                <button type="submit">Reset Password</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ResetPassword;
